import { format, parse } from "date-fns";

import { Authorization } from "../../common/AuthorizationCpt";
import IconShowModal from "../../images/show_modal.svg";
import { formatMoney } from "../../utils/numbers";
import {
  Row,
  TableBody,
} from "../DocumentManagement/DocumentManagementSharedStyles";
import { DeleteButton } from "../IconButtons";
import {
  ContentDiv,
  DivAgent,
  DivAgentName,
  DivConsigneAgent,
  DivFlexCenter,
  DivLine,
  DivNumVol,
  DivRejected,
  DivRucFact,
  StatusB,
} from "./CreditAuthStyles";
import PanelMoreOptions from "./PanelMoreOptions";

const PANEL_TITLES = {
  agent: "AGENTE DE ADUANA",
  date: "FECHA DE RETIRO",
  amount: "MONTO",
};
function CreditInvoices(props) {
  const {
    invoices,
    updateShowModal,
    updateSelected,
    selectedRow,
    useDollars,
    titles,
  } = props;

  const changeFormatDate = (date) => {
    const parsedDate = parse(date, "yyyy-MM-dd", new Date());
    const formateDate = format(parsedDate, "dd/MM/yyyy");
    return formateDate;
  };
  return (
    <TableBody>
      {invoices.map((invoice) => (
        <Row key={invoice.invoice_id} className="item-container">
          <div className="attribute left-align">
            <div className="titles">{titles.payerRuc}</div>
            <div className="left-align">
              <DivConsigneAgent>
                <b>
                  {`${
                    invoice?.credit_payment_detail.payer_ruc.option ===
                    "consignee"
                      ? "Importador"
                      : invoice?.credit_payment_detail.payer_ruc.option ===
                        "third_party_agency"
                      ? "Crédito de Terceros"
                      : "Agente de carga"
                  }`}
                </b>
              </DivConsigneAgent>
              <DivAgentName>
                {invoice?.credit_payment_detail.payer_ruc.name}
              </DivAgentName>
            </div>
          </div>
          <div className="attribute">
            <div className="titles">{titles.status}</div>
            <Authorization
              actions={[
                "invoice.get_invoice_payment_status",
                "invoice.update_invoice_upfront_manual",
              ]}
            >
              <div
                style={{
                  cursor: `${
                    invoice?.payment_status.option === "rejected"
                      ? "pointer"
                      : "not-allowed"
                  }`,
                }}
                onClick={() => {
                  if (invoice?.payment_status.option === "rejected")
                    updateSelected(invoice);
                  selectedRow.current = invoice;
                }}
              >
                <div>
                  <DivRejected statusReject={invoice?.payment_status.option}>
                    <div className="status-reject">
                      <StatusB>{invoice?.payment_status.label}</StatusB>
                    </div>
                  </DivRejected>
                </div>
              </div>
            </Authorization>
          </div>
          <div className="attribute">
            <div className="titles">{titles.amount}</div>
            <div style={{ textAlign: "center" }}>
              {formatMoney(invoice?.sales_invoice_total, useDollars)}
            </div>
          </div>
          <div className="attribute">
            <div className="titles">{titles.actions}</div>
            <div className="actions">
              <PanelMoreOptions
                width="62rem"
                height="auto"
                background="#002E6C"
                img={IconShowModal}
              >
                <ContentDiv
                  style={{ color: "#989CA2" }}
                  className="panel-header"
                >
                  <div className="agent-aduana">
                    <b>{PANEL_TITLES.agent}</b>
                  </div>
                  <DivFlexCenter>
                    <b>{PANEL_TITLES.date}</b>
                  </DivFlexCenter>
                  <DivFlexCenter>
                    <b>{PANEL_TITLES.amount}</b>
                  </DivFlexCenter>
                </ContentDiv>
                {invoice?.quotations.map((data, i) => {
                  return (
                    <div key={i} className="item-container">
                      <ContentDiv style={{ marginTop: "2.2rem" }}>
                        <div className="attribute">
                          <div className="titles">{PANEL_TITLES.agent}</div>
                          <div className="agent-aduana">
                            <DivRucFact>
                              {data?.billable_ruc_name.toLocaleUpperCase()}
                            </DivRucFact>
                            <DivAgent>{data?.agent_name}</DivAgent>
                            <DivNumVol>
                              <b>{data?.volante_num}</b>
                            </DivNumVol>
                          </div>
                        </div>
                        <div className="attribute">
                          <div className="titles">{PANEL_TITLES.date}</div>
                          <DivFlexCenter style={{ fontSize: "1.5rem" }}>
                            <div>{changeFormatDate(data?.withdrawal_date)}</div>
                          </DivFlexCenter>
                        </div>
                        <div className="attribute">
                          <div className="titles">{PANEL_TITLES.amount}</div>
                          <DivFlexCenter
                            style={{
                              fontSize: "1.5rem",
                              color: "#000000",
                            }}
                          >
                            <b>
                              {formatMoney(data?.sales_price_total, useDollars)}
                            </b>
                          </DivFlexCenter>
                        </div>
                      </ContentDiv>
                      <DivLine />
                    </div>
                  );
                })}
              </PanelMoreOptions>
              <Authorization actions={["invoice.update_invoice_rollback"]}>
                {(invoice?.payment_status.option === "rejected" ||
                  invoice?.payment_status.option === "expired") && (
                  <DeleteButton
                    tooltipText="Eliminar"
                    onClick={() => {
                      updateShowModal(true);
                      selectedRow.current = invoice;
                    }}
                  />
                )}
              </Authorization>
            </div>
          </div>
        </Row>
      ))}
    </TableBody>
  );
}

export default CreditInvoices;
